import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Box, FormControl, FormLabel, Grid, GridItem, Heading, Input } from '@chakra-ui/react'
import { UiSelect } from 'components/common'
import { getCustomers } from 'api'

export const EdgeCustomerForm = ({ form, setForm, ...rest }) => {
  const loadCustomers = useCallback((page, search) => getCustomers(page, 20, search, 'name', 'asc'), [])

  return (
    <Box {...rest}>
      <Heading size="md" mb={4}>Customer</Heading>
      <Grid
        templateColumns="5fr 1fr"
        gap={4}
        w="900px"
        maxW="100%"
      >
        <GridItem>
          <Grid
            templateColumns="repeat(4, 1fr)"
            gap={4}
          >
            <GridItem colSpan={4}>
              <FormControl isRequired>
                <FormLabel>Select a customer</FormLabel>
                <UiSelect
                  value={form.customer}
                  onChange={v => {
                    setForm(draft => { draft.customer = v })
                  }}
                  loadData={loadCustomers}
                  apiRespProp="rows"
                  getOptionValue={v => v.id}
                  getOptionLabel={v => `${v.company}, ${v.firstname} ${v.lastname}`}
                  placeholder="Search"
                  noOptionsMessage={() => 'No Customers Found'}
                  required={true}
                />
              </FormControl>
            </GridItem>
            {form.customer && (
              <>
                <GridItem colSpan={2}>
                  <FormControl>
                    <FormLabel>Name</FormLabel>
                    <Input name="customer-name" value={`${form.customer.firstname} ${form.customer.lastname}`} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={2}>
                  <FormControl>
                    <FormLabel>Company</FormLabel>
                    <Input name="customer-company" value={form.customer.company} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={4}>
                  <FormControl>
                    <FormLabel>Address</FormLabel>
                    <Input name="customer-address" value={form.customer.address} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={2}>
                  <FormControl>
                    <FormLabel>City</FormLabel>
                    <Input name="customer-city" value={form.customer.city} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel>State</FormLabel>
                    <Input name="customer-state" value={form.customer.state} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={1}>
                  <FormControl>
                    <FormLabel>Zip</FormLabel>
                    <Input name="customer-zip" value={form.customer.zip} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={2}>
                  <FormControl>
                    <FormLabel>Phone</FormLabel>
                    <Input name="customer-phone" value={form.customer.phone} readOnly />
                  </FormControl>
                </GridItem>
                <GridItem colSpan={2}>
                  <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input name="customer-email" value={form.customer.email} readOnly />
                  </FormControl>
                </GridItem>
              </>
            )}
          </Grid>
        </GridItem>
        <GridItem></GridItem>
      </Grid>
    </Box>
  )
}

EdgeCustomerForm.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func
}
